import { render } from "./LiteDialogPanel.vue?vue&type=template&id=1420fbae&scoped=true"
import script from "./LiteDialogPanel.vue?vue&type=script&lang=js"
export * from "./LiteDialogPanel.vue?vue&type=script&lang=js"

import "./LiteDialogPanel.vue?vue&type=style&index=0&id=1420fbae&lang=scss&scoped=true"
import "./LiteDialogPanel.vue?vue&type=style&index=1&id=1420fbae&lang=scss"
script.render = render
script.__scopeId = "data-v-1420fbae"

export default script